export const maintenanceWorkflowStatus: Record<string, string> = {
  pending: 'Pendente',
  in_progress: 'Em andamento',
  completed: 'Completo',
  canceled: 'Cancelado',
}

export const maintenanceWorkflowStatusBackground: Record<string, string> = {
  pending: 'bg-neutral-op-8',
  in_progress: 'bg-blue-300',
  completed: 'bg-success-op',
  canceled: 'bg-danger-op',
}
